// Where the CONTENT lives (blogs, city pages, cabs-json, FAQs, home screen).
//
// Since the 25 Jul 2026 cutover, REACT_APP_BACKEND_URL points at Zenia Fleets,
// which owns the BOOKING flow (fares, enquiries, coupons, payment). The CMS
// content still lives in the legacy backend, so content fetches go there
// DIRECTLY — an extra hop through the fleet box on 790 prerendered SEO pages
// is measurable page-speed and made the prerender time out. The fleet box also
// proxies these endpoints as a server-side fallback, so either base works;
// this one is simply the shortest path.
export const CMS_BASE =
  (typeof process !== "undefined" && process.env?.REACT_APP_CMS_URL) ||
  "https://customerapi.pulpitcabs.com";
